exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table-custom {\n    background: rgb(191, 191, 191) !important;\n    color: #612323 !important;\n}\n\n", ""]);

// exports
